import styled from "styled-components";
import { Link } from "react-router-dom";
import { HORIZONTAL_PADDING_PAGE_DEFAULT, MAX_WIDTH_PAGE } from "../../styles";

export const Container = styled.section`
	width: 100%;
`;

export const Hero = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	align-items: center;
	gap: 24px;

	width: 100%;
	max-width: ${MAX_WIDTH_PAGE};
	margin: 0 auto;
	padding: 32px ${HORIZONTAL_PADDING_PAGE_DEFAULT.SM};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
		grid-template-columns: minmax(0, 1fr) minmax(0, 0.85fr);
		gap: 32px;
		padding: 40px ${HORIZONTAL_PADDING_PAGE_DEFAULT.MD};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
		gap: 48px;
		padding: 56px ${HORIZONTAL_PADDING_PAGE_DEFAULT.MD};
	}
`;

export const HeroContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 16px;
`;

export const Badge = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 8px;

	padding: 6px 12px;
	border-radius: 999px;

	background-color: ${({ theme }) => theme.palette.secondary.orange50};
	color: ${({ theme }) => theme.palette.secondary.orange600};

	font-size: ${12 / 16}rem;
	font-weight: 600;
	letter-spacing: 0.02em;
	text-transform: uppercase;

	svg {
		width: ${16 / 16}rem;
		height: ${16 / 16}rem;
	}
`;

export const Title = styled.h1`
	font-size: ${26 / 16}rem;
	font-weight: 700;
	line-height: 1.2;
	color: ${({ theme }) => theme.palette.greyscale.grey900};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
		font-size: ${36 / 16}rem;
	}
`;

export const Description = styled.p`
	max-width: 520px;

	font-size: ${14 / 16}rem;
	line-height: 1.6;
	color: ${({ theme }) => theme.palette.greyscale.grey500};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
		font-size: ${16 / 16}rem;
	}
`;

export const Actions = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 12px;

	margin-top: 8px;
	width: 100%;
`;

const actionBase = `
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 8px;

	height: 48px;
	padding: 0 24px;
	border-radius: 8px;

	font-size: 0.875rem;
	font-weight: 600;
	text-decoration: none;

	transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;

	svg {
		width: 1.125rem;
		height: 1.125rem;
	}
`;

export const PrimaryAction = styled(Link)`
	${actionBase};

	flex: 1 1 100%;
	background-color: ${({ theme }) => theme.palette.primary.blue500};
	color: #ffffff;

	&:hover {
		background-color: ${({ theme }) => theme.palette.primary.blue600};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.mobileXs}) {
		flex: 0 0 auto;
	}
`;

export const SecondaryAction = styled(Link)`
	${actionBase};

	flex: 1 1 100%;
	border: 1px solid ${({ theme }) => theme.palette.greyscale.grey100};
	color: ${({ theme }) => theme.palette.greyscale.grey700};

	&:hover {
		border-color: ${({ theme }) => theme.palette.greyscale.grey300};
		background-color: ${({ theme }) => theme.palette.greyscale.grey50};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.mobileXs}) {
		flex: 0 0 auto;
	}
`;

export const HeroIllustration = styled.div`
	/* Single column stacks the illustration above the message. */
	order: -1;

	display: flex;
	align-items: center;
	justify-content: center;

	img {
		width: 100%;
		max-width: 260px;
		height: auto;
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
		order: 0;
		justify-content: flex-end;

		img {
			max-width: 340px;
		}
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
		img {
			max-width: 440px;
		}
	}
`;

export const SimilarPropertiesSection = styled.div`
	border-top: 1px solid ${({ theme }) => theme.palette.greyscale.grey50};
	padding: 8px 0 24px;
`;
